import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _typeof from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { dataSummary, dataSummary_currency, summary_currency_other } from "@/api/dataAll/dataSummary";
import { screenDataAdd, screenDataGet } from "@/api/user";
import * as echarts from "echarts";
export default {
  name: "dataSummaryScreen",
  mixins: [tabulation],
  data: function data() {
    return {
      searchData: {
        kind: 1,
        all_countries: 0
      },
      PercentageUnit: ["CR", "PR", "NPR", "pay_account_percent", "sameday", "otherday"],
      pageData: {},
      tableData: [],
      dates: [],
      DNU_DAU: [],
      DND_DNU: [],
      screenArr: [{
        label: "日期.Date",
        prop: "date",
        isfixed: true,
        classname: "font-bold",
        tabText: "2020-01-01"
      }, {
        label: "总收入.Revenue",
        prop: "recharge_account_amount",
        tabText: "RevenueA",
        desc: "包含IAP内购和IAA广告收入的总流水收入"
      }, {
        label: "内购付费收入.Rev-IAP",
        prop: "Rev-IAP",
        tabText: "内购付费收入A",
        desc: "通过内购充值的付费总额"
      }, {
        label: "活跃账号.DAU",
        prop: "active_account_num",
        tabText: "活跃账号A",
        desc: "当日登录过所有账号数"
      }, {
        label: "新增账号.DNU",
        prop: "new_account_num",
        tabText: "新增账号A",
        desc: "当日新增的账号数"
      }, {
        label: "新增活跃比",
        prop: "DNU_DAU",
        tabText: "新增活跃比A",
        desc: "DNU/DAU"
      }, {
        label: "非新增活跃账号数",
        prop: "DAU_DNU",
        tabText: "非新增活跃账号数",
        desc: "DAU-DNU "
      }, {
        label: "付费账号数.DPU",
        prop: "recharge_account_num",
        tabText: "付费账号数A",
        desc: "当日有过付费的账号数"
      }, {
        label: "活跃付费率.PR",
        prop: "PR",
        tabText: "活跃付费率A",
        desc: "付费账号数/活跃账号"
      }, // {
      //   label: '付费率.PUR',
      //   prop: 'pay_account_percent',
      //   tabText: '付费率'
      // },
      {
        label: "活跃用户人均付费.ARPU",
        prop: "pay_account_arpu",
        tabText: "活跃用户人均付费A",
        desc: "内购付费收入/活跃账号"
      }, {
        label: "付费用户人均付费.ARPPU",
        prop: "pay_account_arppu",
        tabText: "付费用户人均付费A",
        desc: "内购付费收入/内购付费账号数"
      }, {
        label: "新增设备.DND",
        prop: "new_device_num",
        tabText: "新增设备A",
        desc: "游戏上报的激活设备数"
      }, {
        label: "新增设备账号比",
        prop: "DND_DNU",
        tabText: "新增设备账号比A",
        desc: "DND/DNU"
      }, {
        label: "新增账号付费总额.RevNU",
        prop: "register_recharge_amount",
        tabText: "新增账号付费总额A",
        desc: "新增账号内购总付费"
      }, {
        label: "新增付费账号数.PNU",
        prop: "register_recharge_pnum",
        tabText: "新增付费账号数A",
        desc: "新增账号有付费的账号数"
      }, {
        label: "新增付费率.NPR",
        prop: "NPR",
        tabText: "新增付费率A",
        desc: "新增付费账号数/新增账号"
      }, // {
      //   label: '登录账号',
      //   prop: 'login_account_num',
      //   tabText: '登录账号'
      // },
      {
        label: "新增账号人均付费.ARPNU",
        prop: "arpnu",
        tabText: "新增账号人均付费A",
        desc: "新增账号付费总额/新增账号"
      }, {
        label: "新增付费账号人均付费.ARPPNU",
        prop: "arppnu",
        tabText: "新增付费账号人均付费A",
        desc: "新增账号付费总额/新增付费账号数"
      }, {
        label: "新增设备付费金额",
        prop: "new_device_recharge_amount",
        tabText: "新增设备付费金额",
        desc: ""
      }, {
        label: "新增设备付费数",
        prop: "new_device_recharge_num",
        tabText: "新增设备付费数",
        desc: ""
      }, {
        label: "买量消耗",
        prop: "cost",
        tabText: "买量消耗A",
        desc: "当日总广告投放消耗"
      }, {
        label: "新增安装量.Install",
        prop: "Install",
        tabText: "新增安装量A",
        desc: "投放平台返回的总激活数:新增投放量+新增自然量"
      }, {
        label: "新增投放量.I-Ads",
        prop: "I-Ads",
        tabText: "新增投放量A",
        desc: "投放平台返回的通过广告激活的用户数"
      }, {
        label: "新增自然量.I-Organic",
        prop: "I-Organic",
        tabText: "I-OrganicA",
        desc: "投放平台返回的非广告自然量"
      }, {
        label: "自然量K因子.K-Factory",
        prop: "K-Factory",
        tabText: "自然量K因子A",
        desc: "广告量与自然量比值:新增自然量/新增投放量"
      }, {
        label: "安装注册转化率.CR",
        prop: "CR",
        tabText: "安装注册转化率A",
        desc: "安装到注册的转化率:新增账号/新增安装量"
      }, {
        label: "新增安装成本.eCPI",
        prop: "eCPI",
        tabText: "新增安装成本A",
        desc: "买量消耗/新增安装量"
      }, {
        label: "新增账号成本.eCPA",
        prop: "eCPA",
        tabText: "新增账号成本A",
        desc: "买量消耗/新增账号数"
      }, {
        label: "新增次留成本.eCPR",
        prop: "eCPR",
        tabText: "新增次流成本A",
        desc: "买量消耗/次留用户数"
      }, {
        label: "新增付费成本.eCPP",
        prop: "eCPP",
        tabText: "新增付费成本A",
        desc: "买量消耗/新增付费人数"
      }, {
        label: "广告收入.Rev-IAA",
        prop: "Rev-IAA",
        tabText: "广告收入A",
        desc: "通过广告获得的收入"
      }, {
        label: "活跃人均贡献.DARPU",
        prop: "DARPU",
        tabText: "活跃人均贡献A",
        desc: "总收入/活跃账号"
      }, {
        label: "次留用户数",
        prop: "eCPR_count",
        tabText: "次留用户数A",
        desc: "次留用户数"
      }],
      defaultNotShown: ["DNU_DAU", "DND_DNU", "DAU_DNU", "arpnu", "arppnu", "K-Factory", "eCPA", "eCPR", "eCPP", "eCPR_count", "new_device_recharge_amount", "new_device_recharge_num"],
      defaultNotShownL_R_R: [14, 30, 60, 90, 120],
      LTVList: [1, 2, 3, 4, 5, 6, 7, 14, 30, 60, 90, 120],
      acLTVList: [1, 2, 3, 4, 5, 6, 7, 14, 30, 60, 90, 120],
      ROIList: [1, 2, 3, 4, 5, 6, 7, 14, 30, 60, 90, 120],
      acROIList: [1, 2, 3, 4, 5, 6, 7, 14, 30, 60, 90, 120],
      RRList: [2, 3, 4, 5, 6, 7, 14, 30, 60, 90, 120],
      acRRList: [2, 3, 4, 5, 6, 7, 14, 30, 60, 90, 120],
      screen: [],
      sericeArr: [],
      isShow: true,
      wxProp: [{
        label: "安卓充值",
        prop: "android_recharge",
        isfixed: false,
        tabText: "安卓充值"
      }, {
        label: "IOS充值",
        prop: "iOS_recharge",
        isfixed: false,
        tabText: "IOS充值"
      }],
      countryPro: [{
        label: "国家.Country",
        prop: "country",
        isfixed: false,
        tabText: ""
      }],
      countryAllList: [{
        label: "默认",
        value: 0
      }, {
        label: "所有国家",
        value: 1
      }],
      countryShow: false,
      cellStylekeys: ["ROI", "RR", "LTV", "acLTV", "acRR"]
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var queryData, list, clist, newArr;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return screenDataGet();

            case 2:
              queryData = _context.sent;

              _this.initscreenArr();

              list = queryData.data ? JSON.parse(queryData.data) : []; // 去除原动态表头与历史表头不匹配的项

              clist = [];
              list.forEach(function (i) {
                if (_this.screenArr.findIndex(function (c) {
                  return c.prop == i.prop;
                }) > -1) {
                  clist.push(i);
                }
              });
              _this.sericeArr = clist; // screenDataAdd({ data: JSON.stringify(clist) });
              // this.$store.commit("d2admin/serchSelect/setsericeArr", clist);

              _this.screen = (list.length ? list : _this.screenArr).map(function (item) {
                return item.prop;
              });

              if (!list.length) {
                newArr = _this.screen.filter(function (item) {
                  return !_this.defaultNotShown.some(function (ele) {
                    return ele === item;
                  });
                });
                _this.screen = newArr;

                _this.screenControls();
              } // this.searchClickTest().then(res => {
              //   console.log(res)
              // })


            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 初始化表头数据
    initscreenArr: function initscreenArr() {
      var _this2 = this;

      this.LTVList.forEach(function (i) {
        _this2.screenArr.push({
          label: "LTV" + i,
          prop: "LTV" + i,
          tabText: "LTV" + (i == 1 ? "".concat(i, "A") : i),
          desc: i == 1 ? "首日用户平均价值" : ""
        });
      });
      this.acLTVList.forEach(function (i) {
        _this2.screenArr.push({
          label: "激活设备LTV" + i,
          prop: "acLTV" + i,
          tabText: "激活设备LTV" + (i == 1 ? "".concat(i, "A") : i),
          desc: i == 1 ? "首日激活设备平均价值" : ""
        });
      });
      this.ROIList.forEach(function (i) {
        _this2.screenArr.push({
          label: "ROI" + i,
          prop: "ROI" + i,
          tabText: "ROI" + (i == 1 ? "".concat(i, "A") : i),
          desc: i == 1 ? "首日投放回本率" : ""
        });
      }); // this.acROIList.forEach((i) => {
      //   this.screenArr.push({
      //     label: "激活设备ROI" + i,
      //     prop: "acROI" + i,
      //     tabText: "激活设备ROI" + (i == 1 ? `${i}A` : i),
      //     desc: i == 1 ? "首日激活设备投放回本率" : "",
      //   });
      // });

      this.RRList.forEach(function (i) {
        _this2.screenArr.push({
          label: "RR" + i,
          prop: "RR" + i,
          tabText: "RR" + (i == 2 ? "".concat(i, "A") : i),
          desc: i == 2 ? "次日留存率" : ""
        });

        _this2.PercentageUnit.push("RR" + i);
      });
      this.acRRList.forEach(function (i) {
        _this2.screenArr.push({
          label: "激活设备RR" + i,
          prop: "acRR" + i,
          tabText: "激活设备RR" + (i == 2 ? "".concat(i, "A") : i),
          desc: i == 2 ? "次日留存率" : ""
        });

        _this2.PercentageUnit.push("acRR" + i);
      });
      this.defaultNotShownL_R_R.forEach(function (i) {
        _this2.defaultNotShown.push("LTV" + i);

        _this2.defaultNotShown.push("acLTV" + i);

        _this2.defaultNotShown.push("ROI" + i);

        _this2.defaultNotShown.push("RR" + i);

        _this2.defaultNotShown.push("acRR" + i);
      });
    },
    screenControls: function screenControls() {
      var _this3 = this;

      this.isShow = false;
      var list = [];
      this.screenArr.forEach(function (i) {
        if (_this3.screen.findIndex(function (t) {
          return t == i.prop;
        }) !== -1) {
          list.push(i);
        }
      });
      this.sericeArr = list;

      if (this.tableData.length) {
        setTimeout(function () {
          _this3.isShow = true;

          _this3.$nextTick(function () {
            _this3.columnDropInit();
          });
        }, 200);
        this.getechart();
      }

      screenDataAdd({
        data: JSON.stringify(list)
      });
      this.$nextTick(function () {
        _this3.setTableRight(0);
      }); // this.$store.commit("d2admin/serchSelect/setsericeArr", list);
    },
    // 重置筛选
    ResetFilter: function ResetFilter() {
      var _this4 = this;

      var newArr = this.screenArr.filter(function (item) {
        return !_this4.defaultNotShown.some(function (ele) {
          return ele === item.prop;
        });
      });
      this.screen = newArr.map(function (i) {
        return i.prop;
      });
      this.screenControls();
      this.searchClick();
    },
    searchClickTest: function searchClickTest() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var queue, dates, datesList, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                queue = [];
                dates = _this5.$times.getDayAll('2024-10-12', '2024-12-12');
                datesList = [];
                dates.map(function (j, index) {
                  console.log(parseInt(index / 20));
                }); // let num = Math.ceil(dates.length / 20) + 1
                // for (let i = 0; i < num; i++) {
                //   if (i != 0) {
                //     dates.map((j, index) => {
                //       console.log((index + 1) / (i * 20))
                //     })
                //   }
                // }

                data = [{
                  starttime: '2024-11-12',
                  endtime: '2024-11-22'
                }, {
                  starttime: '2024-11-23',
                  endtime: '2024-12-02'
                }, {
                  starttime: '2024-12-03',
                  endtime: '2024-12-12'
                }];
                data.forEach(function (i) {
                  queue.push(dataSummary_currency(_objectSpread(_objectSpread(_objectSpread({}, _this5.searchData), _this5.defaultData()), i)));
                }); // return await Promise.all(queue)

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    searchClick: function searchClick() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // if(this.currencyClose && !this.searchData.currency_info){
                //   this.$message.error('请选择货币类型')
                //   return
                // }
                if (_this6.value2.length > 0) {
                  _this6.searchData.starttime = _this6.value2[0];
                  _this6.searchData.endtime = _this6.value2[1];
                } // if(this.$times.differenceTime(this.searchData.starttime,this.searchData.endtime) > 31){
                //   this.$message.error('最多只能查询31天的数据')
                //   return
                // }


                _this6.dates = [];
                _this6.reqLoading = true;
                _context3.next = 5;
                return _this6.timeInterval();

              case 5:
                reqFn = dataSummary;

                if (_this6.currencyClose && !_this6.searchData.pay_channel) {
                  reqFn = dataSummary_currency;
                } else if (_this6.searchData.pay_channel) {
                  reqFn = summary_currency_other;
                }

                reqFn(_objectSpread(_objectSpread({}, _this6.searchData), _this6.defaultData())).then(function (res) {
                  if (res.status == 200) {
                    var _ret = function () {
                      _this6.reqLoading = false;
                      _this6.isShow = true;
                      _this6.tableData = [];
                      var newData = {};

                      if (JSON.stringify(res.data.data) == "[]") {
                        return {
                          v: void 0
                        };
                      } // 改为


                      res.data.summary.data = res.data.summary.avgData;
                      res.data.summary.acRR = res.data.summary.acRRAvgData;
                      var country = _this6.searchData.country.length ? _this6.searchData.country : [];

                      if (_this6.searchData.all_countries == 1) {
                        country = res.data.countryList; // for(let i in res.data.data){
                        //   for(let k in res.data.data[i]['LTV']){
                        //     country.push(k)
                        //   }
                        //   break
                        // }
                      } // 数据重组


                      if (_this6.searchData.country.length || _this6.searchData.all_countries == 1) {
                        if (country.length) {
                          country.forEach(function (item) {
                            for (var key in res.data.data) {
                              for (var jkey in res.data.data[key]) {
                                if (res.data.data[key][jkey][item]) {
                                  newData[key + "/" + item] = !newData[key + "/" + item] ? {} : newData[key + "/" + item];
                                  newData[key + "/" + item][jkey] = jkey !== "other" ? _objectSpread({}, res.data.data[key][jkey][item]) : _objectSpread(_objectSpread({}, res.data.data[key][jkey][item]), {}, {
                                    country: item
                                  });
                                }
                              }
                            }
                          });
                          newData["总计"] = res.data.summary;
                        }
                      } else {
                        newData = res.data.data;
                        newData["总计"] = res.data.summary;
                      }

                      _this6.countryShow = _this6.searchData.all_countries == 1 || _this6.searchData.country.length ? true : false;
                      _this6.pageData = newData; // 初始化折线图数据

                      for (var key in newData) {
                        for (var i in newData[key].other) {
                          _this6[i] = [];
                        }

                        _this6.LTVList.forEach(function (i) {
                          _this6["LTV" + i] = [];
                        });

                        _this6.acLTVList.forEach(function (i) {
                          _this6["acLTV" + i] = [];
                        });

                        _this6.ROIList.forEach(function (i) {
                          _this6["ROI" + i] = [];
                        }); // this.acROIList.forEach((i) => {
                        //   this["acROI" + i] = [];
                        // });


                        _this6.RRList.forEach(function (i) {
                          _this6["RR" + i] = [];
                        });

                        _this6.acRRList.forEach(function (i) {
                          _this6["acRR" + i] = [];
                        });

                        _this6["DNU_DAU"] = [];
                        _this6["DND_DNU"] = [];
                        break;
                      } // 数据赋值


                      for (var _key in newData) {
                        _this6.dates.push(_key);

                        newData[_key].other.pay_account_arpu = _this6.$utils.conversion(newData[_key].other.pay_account_arpu).toFixed(3);
                        newData[_key].other.pay_account_arppu = _this6.$utils.conversion(newData[_key].other.pay_account_arppu).toFixed(2);
                        newData[_key].other.recharge_account_amount = _this6.$utils.conversion(newData[_key].other.recharge_account_amount).toFixed(2);
                        newData[_key].other.register_recharge_amount = _this6.$utils.conversion(newData[_key].other.register_recharge_amount).toFixed(2);
                        newData[_key].other["Rev-IAA"] = _this6.$utils.conversion(newData[_key].other["Rev-IAA"]).toFixed(2);
                        newData[_key].other["Rev-IAP"] = _this6.$utils.conversion(newData[_key].other["Rev-IAP"]).toFixed(2);
                        newData[_key].other["DARPU"] = _this6.$utils.conversion(newData[_key].other["DARPU"]).toFixed(2);
                        newData[_key].other["eCPI"] = _this6.$utils.conversion(newData[_key].other["eCPI"]).toFixed(2);
                        newData[_key].other["eCPA"] = _this6.$utils.conversion(newData[_key].other["eCPA"]).toFixed(2);
                        newData[_key].other["eCPR"] = _this6.$utils.conversion(newData[_key].other["eCPR"]).toFixed(2);
                        newData[_key].other["eCPP"] = _this6.$utils.conversion(newData[_key].other["eCPP"]).toFixed(2);
                        newData[_key].other["cost"] = _this6.$utils.conversion(newData[_key].other["cost"]).toFixed(2);
                        newData[_key].other["new_device_recharge_amount"] = _this6.$utils.conversion(newData[_key].other["new_device_recharge_amount"]).toFixed(2);
                        newData[_key].other.pay_account_percent = ((newData[_key].other.pay_account_percent - 0) * 100).toFixed(2);
                        newData[_key].other.arpnu = _this6.$utils.conversion(newData[_key].other.arpnu).toFixed(3);
                        newData[_key].other.arppnu = _this6.$utils.conversion(newData[_key].other.arppnu).toFixed(3);
                        newData[_key].other.sameday = _this6.zhuan(newData[_key].other.sameday);
                        newData[_key].other.otherday = _this6.zhuan(newData[_key].other.otherday);
                        newData[_key].other.CR = (newData[_key].other.CR * 100).toFixed(2);
                        newData[_key].other.PR = (newData[_key].other.PR * 100).toFixed(2);
                        newData[_key].other.NPR = (newData[_key].other.NPR * 100).toFixed(2);

                        if (_this6.searchData.channel == "wxminigame") {
                          newData[_key].other.android_recharge = (newData[_key].other.android_recharge / 100).toFixed(2);
                          newData[_key].other.iOS_recharge = (newData[_key].other.iOS_recharge / 100).toFixed(2);
                        }

                        for (var _i in newData[_key].other) {
                          _this6[_i].push(newData[_key].other[_i]);
                        }
                      }

                      var data = JSON.parse(JSON.stringify(_this6.pageData));

                      var _loop = function _loop(_key2) {
                        var arr = {};

                        _this6.screenArr.forEach(function (item) {
                          arr[item.prop] = data[_key2].other[item.prop] || 0;
                        });

                        if (_this6.searchData.channel == "wxminigame") {
                          arr["android_recharge"] = data[_key2].other["android_recharge"];
                          arr["iOS_recharge"] = data[_key2].other["iOS_recharge"];
                        }

                        if (_this6.countryShow) {
                          arr["country"] = data[_key2].other["country"];
                        } // LTV


                        var ltvData = {};

                        for (var li in data[_key2].LTV) {
                          var num = data[_key2].LTV[li] !== "/" ? _this6.$utils.conversion(data[_key2].LTV[li]).toFixed(3) : "0.000"; // let num = this.$utils.conversion('4.5').toFixed(2)

                          ltvData["LTV" + li] = num;

                          _this6["LTV" + li].push(num);
                        } // 激活设备LTV


                        var acltvData = {};

                        for (var _li in data[_key2].acdeLtv) {
                          var _num = data[_key2].acdeLtv[_li] !== "/" ? _this6.$utils.conversion(data[_key2].acdeLtv[_li]).toFixed(3) : "0.000"; // let num = this.$utils.conversion('4.5').toFixed(2)


                          acltvData["acLTV" + _li] = _num;

                          _this6["acLTV" + _li].push(_num);
                        } // ROI


                        var roiData = {};

                        for (var _li2 in data[_key2].ROI) {
                          roiData["ROI" + _li2] = Number(data[_key2].ROI[_li2]).toFixed(3);

                          _this6["ROI" + _li2].push(Number(data[_key2].ROI[_li2]).toFixed(3));
                        } // 激活设备ROI
                        // let acroiData = {};
                        // for (let li in data[key].ROI) {
                        //   acroiData["ROI" + li] = Number(data[key].ROI[li]).toFixed(3);
                        //   this["ROI" + li].push(Number(data[key].ROI[li]).toFixed(3));
                        // }
                        // RR


                        var rrData = {};

                        var _loop2 = function _loop2(_li3) {
                          var nums = Number(_li3);

                          if (_this6.RRList.findIndex(function (i) {
                            return i == nums;
                          }) > -1) {
                            var _num2 = data[_key2].data[_li3] == "/" ? 0 : _this6.zhuan(data[_key2].data[_li3]);

                            rrData["RR" + nums] = _num2;

                            _this6["RR" + nums].push(_num2);
                          }
                        };

                        for (var _li3 in data[_key2].data) {
                          _loop2(_li3);
                        } // acRR


                        var acrrData = {};

                        var _loop3 = function _loop3(_li4) {
                          var nums = Number(_li4);

                          if (_this6.acRRList.findIndex(function (i) {
                            return i == nums;
                          }) > -1) {
                            var _num3 = data[_key2].acRR[_li4] == "/" ? 0 : _this6.zhuan(data[_key2].acRR[_li4]);

                            acrrData["acRR" + nums] = _num3;

                            _this6["acRR" + nums].push(_num3);
                          }
                        };

                        for (var _li4 in data[_key2].acRR) {
                          _loop3(_li4);
                        }

                        _this6.tableData.push(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, arr), ltvData), roiData), rrData), acrrData), acltvData), {}, {
                          date: _key2
                        }));
                      };

                      for (var _key2 in data) {
                        _loop(_key2);
                      }

                      _this6.tableData.reverse();

                      _this6.tableData.map(function (item) {
                        item.date = item.date.split("/")[0];
                        item.timeStamp = _this6.$times.timeStamp(item.date) || 999999999999999;
                      });

                      _this6.tableData.sort(function (a, b) {
                        return b.timeStamp < a.timeStamp ? 1 : -1;
                      }); // this.sericeArr = this.sericeArr.length ? this.sericeArr : this.screenArr;
                      // if (this.searchData.channel == 'wxminigame' ) {
                      //   wxProp.unshift(1, 0)
                      //   Array.prototype.splice.apply(this.sericeArr, wxProp);
                      // }


                      _this6.$nextTick(function () {
                        _this6.columnDropInit();

                        _this6.getTableRight();

                        _this6.getechart();
                      });
                    }();

                    if (_typeof(_ret) === "object") return _ret.v;
                  }
                }).finally(function () {
                  _this6.reqLoading = false;
                });

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    zhuan: function zhuan(data) {
      // let n = []
      // list.forEach((item) => {
      //   n.push(item.length > 0 ? Number(item.substr(0, item.length - 1)) : 0)
      // })
      var d = 0;

      if (data) {
        d = Number(data.substr(0, data.length - 1));
      }

      return d;
    },
    getechart: function getechart() {
      var _this7 = this;

      var chartDom = document.getElementById("dataSummaryScreenEchart");
      var myChart = echarts.init(chartDom);
      var date = JSON.parse(JSON.stringify(this.dates)).splice(0, this.dates.length - 1);
      var newDate = [];
      date.forEach(function (item, index) {
        var strL = item.split("/");
        newDate[index] = {
          date: strL[0],
          timeStamp: _this7.$times.timeStamp(strL[0]),
          country: strL[1]
        };
      });
      newDate.reverse();
      newDate.sort(function (a, b) {
        return b.timeStamp < a.timeStamp ? 1 : -1;
      });
      var newDates = newDate.map(function (i) {
        return i.country ? i.date + "/" + i.country : i.date;
      });
      var newSericeArr = JSON.parse(JSON.stringify(this.sericeArr));
      var wxProp = JSON.parse(JSON.stringify(this.wxProp));

      if (this.searchData.channel == "wxminigame") {
        wxProp.unshift(1, 0);
        Array.prototype.splice.apply(newSericeArr, wxProp);
      }

      var option;
      var legendArr = [];
      var sericeArr = [];
      newSericeArr.forEach(function (item) {
        if (item.prop !== "date") {
          var label = item.label.split(".")[0];
          legendArr.push(label);
          sericeArr.push({
            name: label,
            type: "line",
            data: JSON.parse(JSON.stringify(_this7[item.prop])).splice(0, _this7[item.prop].length - 1),
            smooth: true
          });
        }
      });
      option = {
        title: {
          text: "数据汇总"
        },
        animationDuration: 3000,
        tooltip: {
          trigger: "axis",
          confine: true,
          formatter: function formatter(params) {
            var astr = "";
            astr += "".concat(params[0].axisValue, "<br/>");
            params.forEach(function (ele, index) {
              astr += "<div style=\"display: block;height:20px;".concat(index % 3 === 0 ? "width: 33%;" : "width: 33%;", "float:left;\">\n                        <i style=\"width: 10px;height: 10px;display: inline-block;background: ").concat(ele.color, ";border-radius: 10px;\"></i>\n                        <span>").concat(ele.seriesName, ": ").concat(ele.data, "</span>\n                        </div>");
            });
            var b = '<div style="width: 640px;">' + astr + "<div>";
            return b;
          }
        },
        legend: {
          data: legendArr,
          width: "100%",
          top: "4%",
          icon: "circle",
          itemHeight: 12,
          itemWidth: 15,
          inactiveColor: "#666666",
          formatter: ["{a|{name}}"].join("\n"),
          textStyle: {
            fontSize: 12,
            lineHeight: 12,
            rich: {
              a: {
                width: 120,
                verticalAlign: "middle"
              }
            },
            padding: [0, 0, -2, -4] //[上、右、下、左]

          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "26%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: newDates
        },
        yAxis: {
          type: "value"
        },
        series: sericeArr
      };
      chartDom && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      var _this8 = this;

      var d = JSON.parse(JSON.stringify(this.tableData));
      var newSericeArr = JSON.parse(JSON.stringify(this.sericeArr));
      var wxProp = JSON.parse(JSON.stringify(this.wxProp));

      if (this.searchData.channel == "wxminigame") {
        wxProp.unshift(1, 0);
        Array.prototype.splice.apply(newSericeArr, wxProp);
      }

      var columns = _toConsumableArray(newSericeArr);

      if (this.countryShow) {
        columns.splice(1, 0, {
          label: "国家",
          prop: "country"
        });
      }

      d.map(function (item) {
        _this8.PercentageUnit.forEach(function (i) {
          item[i] = item[i] + "%";
        });
      });
      var data = d;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};